import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      data-testid='icon_list'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M8 18h13' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M3 18h.01' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M8 12h13' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M3 12h.01' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M8 6h13' />
      <path fill='none' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M3 6h.01' />
    </svg>
  );
}

export default Icon;
